import { createStore } from 'vuex'

import actions from '@/store/actions'
import mutations from '@/store/mutations'

const store = createStore({
  state: {
    selections: {
      selectedStatus: 'pending',
    },
    presentation: {},
    questions: [],
  },
  actions,
  mutations,
  strict: process.env.NODE_ENV !== 'production',
})

export default store
